export const th = {
    translation: {
        or: "หรือ",
        reset: "รีเซ็ต",
        save: "บันทึก",
        search: "ค้นหา",
        edit: "แก้ไข",
        new: "ใหม่",
        export: "โหลด Excel",
        import: "นำเข้า",
        discard: "ทิ้ง",
        yes: "ใช่",
        no: "ไม่",
        pause: "หยุดชั่วคราว",
        areYouSure: "คุณแน่ใจไหม?",
        view: "ดู",
        destroy: "ลบ",
        mustSelectARow: "ต้องเลือกแถว",
        start: "เริ่ม",
        end: "จบ",
        select: "เลือก",
        continue: "ดำเนินการต่อ",
        filters: "ตัวกรอง",
        status: "สถานะ",
        description: "คำอธิบาย",
        unit: "หน่วย",
        ok: "ตกลง",
        close: "ปิด",
        confirm: "ยืนยัน",
        noDataView: "ไม่มีข้อมูล",
        passed: "ผ่าน",
        failed: "ล้มเหลว",
        msgSuccess: "สำเร็จ",
        msgWarning: "แจ้งเตือน",
        msgError: "ข้อผิดพลาด",
        msgInfo: "ข้อมูล",
        msgConfirm: "ยืนยัน",
        msgHint: "คำใบ้",
        cancel: "ยกเลิก",
        add: "เพิ่ม",
        clear: "ล้าง",
        back: "กลับ",
        approve: "อนุมัติ",
        reject: "ปฏิเสธ",
        submit: "ส่ง",
        download: "ดาว์โหลด",
        create: "สร้าง",
        msgDuplicate: "มีข้อมูลนี้ในระบบแล้ว",
        msgSaveComplete: "บันทึกข้อมูลเรียบร้อยแล้ว",
        msgDeleteComplete: "ข้อมูลถูกลบไปเรียบร้อยแล้ว",
        msgConfirmSave: "คุณต้องการบันทึกข้อมูลหรือไม่ ?",
        msgConfirmSaveDraft: "คุณต้องการบันทึกข้อมูลฉบับร่างหรือไม่ ?",
        msgConfirmDelete: "คุณต้องการลบข้อมูลหรือไม่ ?",
        msgConfirmApprove: "คุณต้องการอนุมัติข้อมูลหรือไม่?",
        msgConfirmRevisit: "คุณต้องการทบทวนข้อมูลหรือไม่?",
        msgConfirmCancel: "คุณต้องการยกเลิกข้อมูลหรือไม่?",
        msgConfirmReject: "คุณต้องการปฏิเสธข้อมูลหรือไม่?",
        msgNoPermission: "คุณไม่มีสิทธิ์เข้าถึงหน้านี้",
        msgSessionTimeOut: "กรุณาเข้าสู่ระบบอีกครั้ง",
        msgDeleteFail: "โปรดเลือก <i class='far fa-check-square'></i>",
        msgUploadImage: "กรุณาอัพโหลดภาพ",
        msgConfirmLogout: "คุณต้องการออกจากระบบ?",
        msgConfirmImport: "คุณต้องการอัปโหลดข้อมูล ?",
        msgConfirmChange: "คุณต้องการเปลี่ยนแปลงข้อมูล ?",
        pleaseSpecify: "กรุณาระบุ",
        noInformationFound: "ไม่พบข้อมูล",
        enterToSearch: "กรอกเพื่อค้นหา",
        searching: "กำลังค้นหา",
        selectAll: "เลือกทั้งหมด",
        all: "ทั้งหมด",
        msgSynchronize: "Do you want to Synchronize data",
        History: "ประวัติ"
    }
}